<template>
  <div class="header">
    <div class="header-lf">
      <!-- 面包屑 -->
      <div class="breadcrumb" v-if="settingConfig.breadcrumb">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item> -->
          <el-breadcrumb-item
            v-for="item in matched"
            :key="item.path"
            :to="{ path: item.redirect ? '' : item.path }"
          >
            {{ item.name }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- logo -->
      <div class="logo">
        <a href="" class="icon" target="_self"
          ><img
            src="https://file.securepago.com/ny/1769221045802_wiio payment logo.png"
            alt=""
        /></a>

        <!-- <img src="../../assets/images/NY.png" alt="" /> -->
      </div>
    </div>

    <div class="header-ri">
      <div class="header-jump">
        <ElButton
          type="primary"
          @click="faqbtn"
          style="
            --el-button-bg-color: #fff;
            --el-button-border-color: var(--el-color-primary);
            --el-button-text-color: var(--el-color-primary);
            --el-button-hover-bg-color: var(--el-color-primary-light-3);
            --el-button-hover-border-color: var(--el-color-primary-light-3);
            --el-button-hover-text-color: var(--current-color-on-dark);
            --el-button-active-bg-color: var(--el-color-primary-dark-2);
            --el-button-active-border-color: var(--el-color-primary-dark-2);
            --el-button-active-text-color: var(--current-color-on-dark);
          "
        >
          {{ $t('faqs') }}
        </ElButton>
      </div>
      <div class="header-jump">
        <ElButton
          type="primary"
          @click="jumpToPlatformLink"
          v-if="platformManager.enable()"
          :loading="tkLoading"
          style="
            --el-button-bg-color: #fff;
            --el-button-border-color: var(--el-color-primary);
            --el-button-text-color: var(--el-color-primary);
            --el-button-hover-bg-color: var(--el-color-primary-light-3);
            --el-button-hover-border-color: var(--el-color-primary-light-3);
            --el-button-hover-text-color: var(--current-color-on-dark);
            --el-button-active-bg-color: var(--el-color-primary-dark-2);
            --el-button-active-border-color: var(--el-color-primary-dark-2);
            --el-button-active-text-color: var(--current-color-on-dark);
          "
          >{{ pushBtnName }}
        </ElButton>
      </div>

      <div class="header-drop">
        <el-dropdown trigger="click" @command="changeLanguage">
          <div class="lang-wrap">
            <img class="drop-img" :src="currentLang?.img" alt="" />
            <span class="lang-text">{{
              currentLang?.name?.toLocaleUpperCase()
            }}</span>
            <el-icon class="icon-drop">
              <CaretBottom />
            </el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="lang in langList"
                :command="lang"
                :style="
                  currentLang?.img === lang.img
                    ? {
                        background: 'var(--el-dropdown-menuItem-hover-fill)',
                        color: 'var(--el-dropdown-menuItem-hover-color)'
                      }
                    : ''
                "
                :key="lang.name"
              >
                <img :src="lang.img" class="drop-img" alt="" />
                <span>{{ lang.name?.toLocaleUpperCase() }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>

      <div class="avatar">
        <el-dropdown trigger="click" @command="setDrop">
          <div class="avatar-wrap">
            <img src="@/assets/images/useravatar.png" alt="avatar" />
            <span>{{ userStore.userInfo?.email }}</span>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="item in dropList"
                :key="item.value"
                :command="item"
              >
                {{ item.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, inject, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { GlobalStore } from '@/store/modules/global'
import { useRoute, useRouter } from 'vue-router'
// import Setting from './components/setting.vue'
import FullScreen from './components/fullScreen.vue'
// import Question from './components/question.vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import useUserStore from '@/store/modules/user'
import enImg from '@/assets/images/en.png'
import esImg from '@/assets/images/es.png'
import brImg from '@/assets/images/br.png'
import deImg from '@/assets/images/de.png'
import frImg from '@/assets/images/fr.png'
import nlImg from '@/assets/images/nl.png'
import svImg from '@/assets/images/sv.png'

import { CaretBottom } from '@element-plus/icons-vue'
import platformManager from '@/service/PlatformManager'

const from = platformManager.getForm()

const globalStore = GlobalStore()
const userStore = useUserStore()
const route = useRoute()
const router = useRouter()

const { settingConfig } = storeToRefs(globalStore)
const { language } = storeToRefs(globalStore)
const { locale } = useI18n()
const tkLoading = ref(false)
const pushBtnName = ref(null)
const searchvalue = ref('')
const $t: any = inject('$t')

const matched = computed(() =>
  route.matched.filter(
    (item) => item.meta && item.meta.title && item.meta.title !== 'Home'
  )
)

interface DropList {
  label: string
  value: string
}

const dropList: Array<DropList> = ref([
  {
    label: $t('logout'),
    value: '退出登录'
  }
])

watch(
  () => globalStore.language,
  () => {
    dropList.value[0].label = $t('logout')
  },
  {
    immediate: true
  }
)

const setDrop = (opt: DropList) => {
  if (opt.value === '退出登录') {
    ElMessageBox.confirm($t('logoutSYS'), $t('tips'), {
      confirmButtonText: $t('confirm'),
      cancelButtonText: $t('cancel'),
      type: 'warning'
    }).then(() => {
      userStore.logout()
      if (from === 'wiio') {
        const wiioHome = import.meta.env.VITE_WIIO_Login
        window.location.href = wiioHome
      } else if (from === 'ud') {
        const udHome = import.meta.env.VITE_UD_Login
        window.location.href = udHome
      } else {
        router.push('/login')
      }
      ElMessage({
        type: 'success',
        message: $t('lougoutsuccess')
      })
    })
  }
}

const langList = ref([
  {
    img: esImg,
    name: 'es'
  },
  {
    img: brImg,
    name: 'pt'
  },
  {
    img: enImg,
    name: 'en'
  }
  // {
  //   img: deImg,
  //   name: 'de'
  // },
  // {
  //   img: frImg,
  //   name: 'fr'
  // },
  // {
  //   img: nlImg,
  //   name: 'nl'
  // },
  // {
  //   img: svImg,
  //   name: 'sv'
  // }
])
const currentLang = ref({
  img: '',
  name: ''
})

const changeLanguage = (data: any) => {
  currentLang.value = data
  globalStore.setLanguage(data.name)
  locale.value = data.name
  localStorage.setItem('language', data.name)
}

const getLanguage = () => {
  if (!localStorage.getItem('language')) {
    localStorage.setItem('language', language.value)
  }
  let lang = localStorage.getItem('language')
  const allowedLangs = ['es', 'pt', 'en', 'zh', 'de', 'nl', 'sv', 'fr']
  if (!lang || !allowedLangs.includes(lang)) {
    localStorage.setItem('language', 'en')
    lang = 'en'
  }
  currentLang.value =
    langList.value.find((f) => f.name === lang) ||
    langList.value.find((f) => f.name === 'en')
}

const jumpToPlatformLink = async () => {
  tkLoading.value = true // 开始loading
  await platformManager.jumpToPlatformLink() // 调用跳转方法
  tkLoading.value = false // 完成后关闭loading
}
const faqbtn = () => {
  router.push('/helpcenter')
}

onMounted(() => {
  getLanguage()
  pushBtnName.value = platformManager.getPushBtnName()
})
</script>

<style lang="scss" scoped>
.header-drop {
  margin-right: 24px;
  display: flex;
  .lang-wrap {
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    .lang-text {
      font-size: 16px;
      font-weight: 400;
      display: inline-block;
      width: 34px;
      text-align: center;
    }
    .icon-drop {
      font-size: 20px;
    }
  }
}

.drop-img {
  width: 24px;
  height: 18px;
  margin-right: 5px;
}

.header {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  color: #fff;
  // border-bottom: 1px solid #e4e7ed;
  box-sizing: border-box;
  background: linear-gradient(
    90deg,
    #ffac68 0%,
    #ff8069 48.56%,
    #ff556b 99.04%
  );
}

.header-lf {
  display: flex;
  align-items: center;
  .logo {
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-left: 10px;
    img {
      width: 268.5px;
      height: 58px;
      object-fit: contain;
    }

    /*> img {
      + img {
        margin-left: 4px;
      }
      &:first-child {
        width: 50px;
        height: 30px;
      }
      &:last-child {
        width: 60px;
        height: 30px;
      }
    }*/
  }
}

.header-search.el-input {
  width: 340px;
  margin-right: 24px;
  height: 40px;
  :deep(.el-input__wrapper) {
    background-color: #80e6e0;
    box-shadow: none;
    .el-input__inner {
      color: #e5faf9;
      &::placeholder {
        color: #e5faf9;
      }
    }
  }
  .el-input__icon {
    font-size: 20px;
    color: #fff;
  }
}

.header-ri {
  margin: 0 10px;
  display: flex;
  align-items: center;
  height: 100%;
  .header-icons {
    display: flex;
    justify-content: center;
    margin-right: 25px;
    height: 100%;
    > div {
      display: flex;
      align-items: center;
      cursor: pointer;
      & + div {
        margin-left: 20px;
      }
    }
  }
}
.header-jump {
  margin-right: 20px;
}

.collapse-icon {
  margin-right: 10px;
  cursor: pointer;
}

.avatar {
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: pointer;

  .avatar-wrap {
    display: flex;
    align-items: center;
    gap: 10px;

    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }

    span {
      color: white;
      font-size: 15px;
    }
  }
}
</style>
